import { LanguageCode, isSupportedLanguage } from './languages';

const normalizePath = (path: string): string => {
  if (!path) return '/';
  return path.startsWith('/') ? path : `/${path}`;
};

const LANGUAGE_URL_SEGMENTS: Record<LanguageCode, string> = {
  sr: 'sr',
  en: 'en',
  ru: 'ru',
  'zh-CN': 'cn',
};

const resolveLanguageFromSegment = (segment?: string): LanguageCode | null => {
  if (!segment) return null;
  if (isSupportedLanguage(segment)) {
    return segment;
  }
  const matchedEntry = Object.entries(LANGUAGE_URL_SEGMENTS).find(
    ([, urlSegment]) => urlSegment.toLowerCase() === segment.toLowerCase()
  );
  return matchedEntry ? (matchedEntry[0] as LanguageCode) : null;
};

const getUrlSegmentForLanguage = (language: LanguageCode): string => {
  return LANGUAGE_URL_SEGMENTS[language] || language;
};

export const getLanguageFromPath = (pathname: string): LanguageCode | null => {
  const firstSegment = pathname.split('/')[1];
  return resolveLanguageFromSegment(firstSegment);
};

export const stripLanguageFromPath = (pathname: string): string => {
  const normalized = normalizePath(pathname);
  const segments = normalized.split('/');
  if (resolveLanguageFromSegment(segments[1])) {
    const rest = segments.slice(2).join('/');
    return rest ? `/${rest}` : '/';
  }
  return normalized;
};

export const buildLocalizedPath = (pathname: string, language: LanguageCode): string => {
  const withoutLanguage = stripLanguageFromPath(pathname);
  const urlSegment = getUrlSegmentForLanguage(language);
  if (withoutLanguage === '/') {
    return `/${urlSegment}`;
  }
  return `/${urlSegment}${withoutLanguage}`;
};
